import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ItemListResponse, Label } from '@models';
import { environment } from '@environment';

@Injectable({
  providedIn: 'root',
})
export class LabelService {
  private http = inject(HttpClient);

  create(label: Label) {
    if (!label.url) {
      delete label.url;
    }
    return this.http.post<Label>(`${environment.kinkoHost}/label/`, label, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    });
  }

  read(id: string) {
    return this.http.get<Label>(`${environment.kinkoHost}/label/${id}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    });
  }

  update(id: string, label: Label) {
    if (!label.url) {
      delete label.url;
    }
    return this.http.put<Label>(`${environment.kinkoHost}/label/${id}`, label, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    });
  }

  delete(id: string) {
    return this.http.delete<void>(`${environment.kinkoHost}/label/${id}`);
  }

  listByType(type: string) {
    return this.http.get<ItemListResponse<Label>>(
      `${environment.kinkoHost}/label/?take=255&type=${type}`,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      },
    );
  }

  // label - dataset relation

  listByDatasetId(datasetId: string) {
    return this.http.get<ItemListResponse<Label>>(
      `${environment.kinkoHost}/label/?take=255&datasetId=${datasetId}`,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      },
    );
  }

  addToDataset(datasetId: string, labelId: string) {
    const url = `${environment.kinkoHost}/dataset/${datasetId}/label/${labelId}`;
    return this.http.post(url, null, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    });
  }

  removeFromDataset(datasetId: string, labelId: string) {
    const url = `${environment.kinkoHost}/dataset/${datasetId}/label/${labelId}`;
    return this.http.delete(url);
  }
}
